<ng-container [formGroup]="metadataFormGroup">
  <div class="row mb-3">
    <div class="col">
      <label i18n>Objet de valeur</label>
      <select class="form-control" formControlName="object">
        <option *ngFor="let value of objectTypeValues" [ngValue]="value">
          {{ getObjectTypeEnum(value) }}
        </option>
      </select>
    </div>
  </div>
  <div class="row row-cols-md-2 row-cols-1 my-3">
    <div class="col">
      <label i18n>Description de l'objet</label>
      <input
        type="text"
        class="form-control"
        formControlName="objectDescription"
      />
    </div>
    <div class="col">
      <label i18n>Somme d'assurance</label>
      <input
        type="number"
        min="0"
        class="form-control"
        formControlName="insuranceSum"
      />
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <label i18n>Couvertures</label>
      <mat-form-field class="lty-input">
        <mat-select
          [formControl]="
            getControl(metadataFormGroup.controls['insurancesTypes'])
          "
          multiple
        >
          <mat-option
            *ngFor="let value of objectInsuranceTypeValues"
            [value]="value"
          >
            {{ getObjectInsuranceTypeLabel(value) }}</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="row my-3">
    <div class="col">
      <div class="col">
        <label i18n
          >Est-il ou a-t-il été assuré pour les branches proposées ?</label
        >
        <div class="form-check">
          <input
            type="radio"
            name="hasInsurance"
            id="hasInsuranceFalse"
            [value]="false"
            formControlName="hasInsurance"
          />
          <label class="form-check-label" for="hasInsuranceFalse"> Non </label>
        </div>
        <div class="form-check">
          <input
            type="radio"
            name="hasInsurance"
            id="hasInsuranceTrue"
            [value]="true"
            formControlName="hasInsurance"
          />
          <label class="form-check-label" for="hasInsuranceTrue"> Oui </label>
        </div>
      </div>
    </div>
  </div>
  <div
    class="row row-cols-md-2 row-cols-1"
    *ngIf="metadataFormGroup.value.hasInsurance"
  >
    <div class="col">
      <label i18n>Nom de compagnie</label>
      <input
        type="text"
        class="form-control"
        formControlName="companyInsuranceName"
      />
    </div>
    <div class="col">
      <label i18n>Numéro de police</label>
      <input
        type="text"
        class="form-control"
        formControlName="policeInsuranceNumber"
      />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label i18n
        >A-t-il subi des sinistres dans les branches proposées ?</label
      >
      <div class="form-check">
        <input
          type="radio"
          name="hasSinister"
          id="hasSinisterFalse"
          [value]="false"
          formControlName="hasSinister"
        />
        <label class="form-check-label" for="hasSinisterFalse"> Non </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasSinister"
          id="hasSinisterTrue"
          [value]="true"
          formControlName="hasSinister"
        />
        <label class="form-check-label" for="hasSinisterTrue"> Oui </label>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="metadataFormGroup.value.hasSinister">
    <div class="col">
      <label i18n>Réclamations</label>
      <input
        type="text"
        class="form-control"
        formControlName="sinisterReason"
      />
    </div>
  </div>
  <div class="row">
    <div class="col">
      <label i18n
        >Une proposition d'assurance pour les branches proposées lui a été
        refusée ou l'acceptation/la poursuite du contrat était-elle conditionnée
        à des conditions aggravées ?</label
      >
      <div class="form-check">
        <input
          type="radio"
          name="hasInsuranceRefused"
          id="hasInsuranceRefusedFalse"
          [value]="false"
          formControlName="hasInsuranceRefused"
        />
        <label class="form-check-label" for="hasInsuranceRefusedFalse">
          Non
        </label>
      </div>
      <div class="form-check">
        <input
          type="radio"
          name="hasInsuranceRefused"
          id="hasInsuranceRefusedTrue"
          [value]="true"
          formControlName="hasInsuranceRefused"
        />
        <label class="form-check-label" for="hasInsuranceRefusedTrue">
          Oui
        </label>
      </div>
    </div>
  </div>
</ng-container>
